import BaseStore from '../../BaseStore';
import TicketStatusModel from '../../../models/Maintenance/Ticket/TicketStatusModel';

class StatusStore extends BaseStore {
  constructor(transportLayer) {
    super(TicketStatusModel, transportLayer);
  }
}

export default StatusStore;



// WEBPACK FOOTER //
// ./src/stores/Maintenance/Ticket/TicketStatusStore.js